import { atom } from 'recoil';

export const isRecordingCloneVoice = atom<boolean>({
    key: 'is-recording-clone-voice',
    default: false,
});
